export default function ExitSessionPageComponent() {
    localStorage.removeItem('key');
    localStorage.removeItem('clid');
    localStorage.removeItem('token');
    window.location.href = '/auth';
    return null;
}
